import { get } from '@webapp-next/lib/request/webapp/apiv2';

const PAGE_SIZE = 500;
// Termination otherwise depends entirely on the server stopping the cursor. A
// regression there would hang the Employment tab in a request loop rather than
// failing, so bound it: 500 x 200 is far beyond any real tenant's area count.
const MAX_PAGES = 200;

// Same rows the V1 OperationalUnit QUERY returns for the caller, but through
// the location-scoped V2 list, which does not require the OperationalUnit ORM
// read privilege. Inactive areas are kept: saved regular-hours rows can still
// reference one.
function toOperationalUnit(area) {
  return {
    Id: parseInt(area.id, 10),
    Company: parseInt(area.locationId, 10),
    OperationalUnitName: area.name,
    WorkType: area.workType || '',
    TrainingModule: (area.trainingModuleIds || []).map(Id => ({ Id })),
  };
}

export default async function areasListByLocations(
  locationIds = [],
  { includeTrainingModules = false } = {}
) {
  const ids = [
    ...new Set(
      locationIds.map(id => parseInt(id, 10)).filter(Number.isInteger)
    ),
  ];
  if (!ids.length) {
    return { success: true, message: '', data: [] };
  }

  const trainingModules = includeTrainingModules
    ? '&includeTrainingModules=true'
    : '';
  const baseUrl =
    `/api/management/v2/areas?limit=${PAGE_SIZE}&excludeSoft=1` +
    `${trainingModules}&filters[]=locationId:in(${ids.join(',')})`;

  const areas = [];
  const seenCursors = new Set();
  let cursor = '';
  for (let page = 0; page < MAX_PAGES; page++) {
    const url = cursor
      ? `${baseUrl}&cursor=${encodeURIComponent(cursor)}`
      : baseUrl;
    const { data } = await get(url);
    areas.push(...(data?.data || []));
    cursor = data?.nextCursor || '';
    if (!cursor || seenCursors.has(cursor)) {
      break;
    }
    seenCursors.add(cursor);
  }

  // The V1 query this replaces sorted by name, and the area pickers render in
  // the order they are given. The cursor returns id order, so sort here rather
  // than show areas in creation order.
  return {
    success: true,
    message: '',
    data: areas
      .map(toOperationalUnit)
      .sort((a, b) =>
        String(a.OperationalUnitName || '').localeCompare(
          String(b.OperationalUnitName || '')
        )
      ),
  };
}
